/* Business Step by Step — small helpers (no dependencies) */
(function () {
  'use strict';

  // 1) Consent checkbox: block any form with [data-bsbs-consent-form] until the box is ticked.
  function bindConsent(form) {
    var box = form.querySelector('input[data-bsbs-consent]');
    if (!box) return;
    var wrap = box.closest('.bsbs-consent');
    var buttons = form.querySelectorAll('[data-bsbs-needs-consent]');
    var stamp = form.querySelector('input[data-bsbs-consent-stamp]');
    function sync() {
      buttons.forEach(function (b) { b.setAttribute('aria-disabled', box.checked ? 'false' : 'true'); });
      if (box.checked && wrap) wrap.classList.remove('bsbs-consent--error');
      if (stamp) stamp.value = box.checked ? 'Yes – ticked before payment (' + new Date().toISOString() + ')' : '';
    }
    box.addEventListener('change', sync);
    form.addEventListener('submit', function (e) {
      if (!box.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (wrap) { wrap.classList.add('bsbs-consent--error'); wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        box.focus();
        return false;
      }
      sync();
    }, true);
    buttons.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!box.checked) {
          e.preventDefault();
          if (wrap) { wrap.classList.add('bsbs-consent--error'); wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          box.focus();
        }
      });
    });
    sync();
  }

  // 2) Product gallery thumbnails.
  function bindGallery(root) {
    var main = root.querySelector('[data-bsbs-main-img], .bsbs-main-img');
    if (!main) return;
    root.querySelectorAll('[data-bsbs-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = btn.getAttribute('data-srcset') || '';
        main.alt = btn.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-bsbs-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  // 3) Mobile sticky buy bar: shows when the main buy box is off screen.
  function bindSticky() {
    var bar = document.querySelector('[data-bsbs-sticky]');
    var target = document.querySelector('[data-bsbs-buybox]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }).observe(target);
  }

  function init() {
    document.querySelectorAll('form[data-bsbs-consent-form], form.bsbs-consent-form').forEach(bindConsent);
    document.querySelectorAll('[data-bsbs-gallery]').forEach(bindGallery);
    bindSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
